<template>
    <v-card class="elavation-1" style="border-radius:4px;"> 
        <v-toolbar flat height="45px">
            <span class="font-weight-bold">Information</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="text-xs-center">
            <p v-html="msg" class="msg-text"></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn title="Ok" class="primary" dark @click="ok" :loading="loading">Ok</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

export default {
    data () {
        return {
            loading: false,
        }
    },
    props:['msg'],
    methods: {
        ok() {
            this.closeDialog()
            this.$emit('ok', null)
        },
        closeDialog() {
            this.$emit('update:dialogOkOnly', false)
        }
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.msg-text {
    margin-top:10px;
}
</style>